<template lang="pug">
div
  Navbar
  section.hero.is-fullheight-with-navbar.ny
    .hero-body
      .container
        h1.title.has-text-white Donate
        h2.subtitle.has-text-white If you support our work, please consider donating to one of the following charities
        .columns
          .column.is-narrow
            h2.subtitle.has-text-white.has-text-weight-bold The Black Lives Matter movement
            b-button(type="is-purple", tag="a", href="https://www.blackvisionsmn.org/about", target="_blank")
              span  Black Visions Collective
            br
            br
            b-button(type="is-purple", tag="a", href="https://www.joincampaignzero.org", target="_blank")
              span  Campaign Zero
          .column.is-narrow
            h2.subtitle.has-text-white.has-text-weight-bold Save the Environment
            b-button(type="is-purple", tag="a", href="https://www.greenpeace.org/usa/", target="_blank")
              span  Greenpeace
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBookmark } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

import Navbar from "@/components/Navbar.vue";

library.add(faBookmark, faInstagram);

export default {
  name: "Charity",

  components: {
    Navbar
  }
};
</script>

<style lang="scss">
.ny {
  background-image: url("../assets/ny.jpeg");
  background-color: black;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
